import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useDrawerStore = defineStore('drawer', () => {
  const isOpen = ref(true);
  const isRail = ref(false);

  const toggle = () => {
    isOpen.value = !isOpen.value;
  };

  const open = () => {
    isOpen.value = true;
  };

  const close = () => {
    isOpen.value = false;
  };

  const toggleRail = () => {
    isRail.value = !isRail.value;
  };

  return {
    isOpen,
    isRail,
    toggle,
    toggleRail,
    open,
    close,
  };
});
